<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("package_forms") }}</h5>
    </template>
    <template slot="body">
      <app-table :id="tableId" :options="options" @action="getListAction" />
    </template>
    <template slot="footer">
      <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
        {{ $t("close") }}
      </button>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import * as actions from "../../../../Config/ApiUrl";
import { axiosPost } from "../../../../Helpers/AxiosHelper";

export default {
  name: "PackageTemplateViewModal",
  mixins: [ModalMixin, TableHelpers],
  props: {
    id: Number,
  },
  data() {
    return {
      modalId: "package-forms-view-Modal",
      tableId: "package-templates-table",
      rowData: {},
      options: {
        name: "PackageTemplatesTable",
        url: actions.PACKAGE_FORMS_LIST + "/" + this.id,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "name",
            modifier: (value) => `<span>${this.$t(value || "---")}</span>`,
          },
          {
            title: this.$t("type"),
            type: "custom-html",
            key: "is_file_folder",
            modifier: (value) => `<span>${this.$t(value || "---")}</span>`,
          },
          {
            title: this.$t("business_category"),
            type: "custom-html",
            key: "form_category",
            modifier: (value) => `<span>${this.$t(value ? value.title : "---")}</span>`,
          },
          {
            title: this.$t("created_by"),
            type: "custom-html",
            key: "user",
            modifier: (value) => `<span>${this.$t(value ? value.full_name : "---")}</span>`,
          },
        ],
        actions: [
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    getListAction(rowData, actionObj) {
      this.rowData = rowData;

      if (actionObj.title === this.$t("delete")) {
        this.deleteTemplate();
      }
    },
    deleteTemplate() {
      axiosPost(actions.PACKAGE_FORM_DELETE, {
        package_id: this.id,
        form_id: this.rowData.id,
      })
        .then((response) => {
          this.$toastr.s(response.data.message);
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
  },
};
</script>
